module.exports = "<div class=\"app-component\">\n    <router-outlet></router-outlet>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main